const myOrderList = []

export default {
  myOrderList
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-order/store/state.js